import React from 'react'
import { destroy, submit } from 'redux-form'
import Flex from 'typescript-styled-flex'
import { Trans, withTranslation, WithTranslation } from 'react-i18next'
import { FiSave } from 'react-icons/fi'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import Scrollbars from 'react-custom-scrollbars'
import { FORM_NAME } from '../../../containers/Form/CreateReservation/withReduxForm'
import { IStore } from '../../../reducers'
import Button from '../../Template/Button'
import { ModalHeader, ModalHeaderLabel } from '../../Template/Modal'
import { getModalConfigIsOpen } from '../../../reducers/bookingCalendar/selectors/getModalOpen'
import { ToggleCreateModal } from '../../../actions/bookingCalendar/reservationModal/toggleConfigurationModal'
import ModalReservation from '../../../containers/Form/CreateReservation/ModalReservation'
import styled from '../../../theme'
import { Desktop, is, Mobile } from '../../MediaQuery'
import Icon from '../../Template/Modal/CloseButton/Icon'
import ModalFlexOverflow from '../../Template/Modal/ModalFlexOverflow'
import useSize from '../../../hooks/useSize'
import { ConfigModalWrapper } from './ModalWrapper'

const Scroll = styled(Scrollbars)`
  & > div {
    overscroll-behavior: contain;
  }
`

const Modal = ({
                 open,
                 close,
                 submitForm,
               }: IConfigModalDispatch & IConfigModalProps & WithTranslation) => {
  const isDesktop = is.desktop()
  const size = useSize()

  return (
    <ModalFlexOverflow
      style={{ maxHeight: '100%' }}
      open={open}
      onClose={close}
    >
      <ConfigModalWrapper
        style={{
          maxHeight: '95%',
          maxWidth: '90vw',
          overflowY: isDesktop ? 'hidden' : 'scroll',
          overscrollBehavior: 'contain',
        }}
      >
        <ModalHeader
          style={{
            padding: `${1 * size}em`,
            paddingBottom: `${10 * size}px`,
            paddingTop: `${1 * size}em`,
          }}
        >
          <Flex style={{ width: '100%' }} justifyStart={true}>
            <ModalHeaderLabel style={{ fontSize: `${16 * size}px` }}>
              <Trans i18nKey={'configuration'}/>
            </ModalHeaderLabel>
          </Flex>

          <Flex
            style={{ height: 'auto', width: '20%' }}
            justifyEnd={true}
            alignCenter={true}
          >
            <Icon style={{ marginRight: `${-4 * size}px` }} onClick={close}/>
          </Flex>
        </ModalHeader>

        <Flex full={true} style={{ width: 'auto' }}>
          <Desktop>
            <Scroll
              autoHeight={true}
              autoHeightMin={'60vh'}
              hideTracksWhenNotNeeded={true}
            >
              <ModalReservation/>
            </Scroll>
          </Desktop>
          <Mobile>
            <ModalReservation/>
          </Mobile>
        </Flex>
        <Flex>
          <Button
            size={size}
            as={'button'}
            type={'submit'}
            style={{ margin: `${1 * size}em`, width: '100%' }}
            onClick={submitForm}
            primary={true}
          >
            <div style={{ marginRight: `${5 * size}px` }}>
              <FiSave size={`${16 * size}px`}/>
            </div>
            <Trans i18nKey={'save'}>Zapisz</Trans>
          </Button>
        </Flex>
      </ConfigModalWrapper>
    </ModalFlexOverflow>
  )
}

export interface IConfigModalProps {
  open?: boolean
}

export interface IConfigModalDispatch {
  close?: () => void
  submitForm?: () => void
}

const mapStateToProps = (state: IStore): IConfigModalProps => ({
  open: getModalConfigIsOpen(state),
})

const mapDispatchToProps = (dispatch: Dispatch): IConfigModalDispatch => ({
  close: () => {
    dispatch(ToggleCreateModal(false))
    dispatch(destroy('config_form'))
  },
  submitForm: () => dispatch(submit(FORM_NAME)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Modal))
